/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiSanctionHitType,
    ApiSanctionHitTypeFromJSON,
    ApiSanctionHitTypeToJSON,
    SanctionHitsPage,
    SanctionHitsPageFromJSON,
    SanctionHitsPageToJSON,
} from '../models';

export interface FindSanctionHitsRequest {
    page: number;
    size: number;
    sanctionAlertId: number;
    type?: ApiSanctionHitType;
}

/**
 * 
 */
export class SanctionHitApi extends runtime.BaseAPI {

    /**
     * Fetches sanction hits
     */
    async findSanctionHitsRaw(requestParameters: FindSanctionHitsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SanctionHitsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findSanctionHits.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findSanctionHits.');
        }

        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling findSanctionHits.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.sanctionAlertId !== undefined) {
            queryParameters['sanctionAlertId'] = requestParameters.sanctionAlertId;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/hits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SanctionHitsPageFromJSON(jsonValue));
    }

    /**
     * Fetches sanction hits
     */
    async findSanctionHits(requestParameters: FindSanctionHitsRequest, initOverrides?: RequestInit): Promise<SanctionHitsPage> {
        const response = await this.findSanctionHitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
